import { enqueueSnackbar } from 'notistack';
import React from 'react';
import { Modal, Box, Text, Button, Icons } from '@/theme/index';
import { StyledBox, StyledButton } from './components';

export function NewApiKeyModal({
  open,
  handleClose,
  keyId,
}: {
  open: boolean;
  handleClose: () => void;
  keyId: string;
}) {
  const handleCopyClick = () => {
    enqueueSnackbar('Copied secret key to clipboard', { variant: 'success' });
    navigator.clipboard.writeText(keyId);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <StyledBox>
        <Text variant="h2" textAlign="center">
          This is your Private API key
        </Text>
        <Text variant="body2" textAlign="center">
          Save this key in a safe location, this is the only time you will be
          able to view it!
        </Text>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <StyledButton onClick={handleCopyClick}>
            <Text color="primary">
              {keyId}
              <Icons.ContentCopy
                fontSize="small"
                sx={{ marginLeft: 1 }}
                color="primary"
              />
            </Text>
          </StyledButton>
          <Button variant="contained" onClick={handleClose} color="success">
            Got it!
          </Button>
        </Box>
      </StyledBox>
    </Modal>
  );
}
